import React, { forwardRef, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
//import jsPDF from "jspdf";

//Services
import * as Service from "../../../services/Service.js";
import Constants from "../../../services/Constants.js";
import swal from "sweetalert";

//Import Preloader
import LoadingSpinnerOpaque from "services/LoadingSpinnerOpaque";

import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TablePagination,
  Typography,
  TextField,
  Card,
  CardHeader,
  CardActions,
  CardContent,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  FormHelperText,
} from "@material-ui/core";

import ExportButtons from "../../../components/ExportButtons.js";

import Autocomplete from '@material-ui/lab/Autocomplete';
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";


import { useTranslation } from "react-i18next";

import { Button } from "reactstrap";
import { useQuery, useMutation, useQueryClient } from "react-query";

import * as api from "../../../actions/api.js";
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { DeleteOutline, ViewList, preview, Edit } from "@material-ui/icons";
import { cellFocusEditor } from "../../../services/Common.js";
import moment from "moment";

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

const ProvisionalSummaryReportGlobal = (props) => {

  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const FacilityId = localStorage.getItem("FacilityId");
  const FacilityName = localStorage.getItem("FacilityName");
  const menukey = "provisional-summary-report";
  const UserInfo = sessionStorage.getItem("User_info")
  ? JSON.parse(sessionStorage.getItem("User_info"))
  : 0;
  const UserName = UserInfo == 0 ? "" : UserInfo[0].id;

  const classes = useStyles();
  let tblRef = null;
  const tableRef = useRef();
  const { useState } = React;

  const [firstLoad, setFirstLoad] = useState(true);

  const [ManyJsonSave, setInputChange] = useState({});
  //const [radioValue, setRadioValue] = useState(2);
  const [productGroupData, selectProductGroupData] = useState();
  const [dataItems, setDataItems] = useState([]);

  const [manyTableData, setManyTableData] = useState([]);
  const GroupNameList = JSON.parse(localStorage.getItem("GroupNameList"));
  const [currContractNo, setcurrContractNo] = useState(0);
  let TempItemList = useState([]);
  const [ItemList, setItemListLocal] = useState(TempItemList);
  const [currItemCode, setcurrItemCode] = useState(0);
  const [ContractlistAll, setContractlistAll] = useState([]); //JSON.parse(localStorage.getItem("ContractlistAll"));
  const [Conractcheck, setConractcheck] = React.useState(true);
  const { t, i18n } = useTranslation();
  const queryClient = useQueryClient();

  const FacilityList = JSON.parse(localStorage.getItem("FacilityListGlobal"));

  const [currFacilityCode, setcurrFacilityCode] = useState(FacilityList.length>0? FacilityList[0].id:"");
  const [currFacilityName, setcurrFacilityName] = useState(FacilityList.length>0? FacilityList[0].name:"");
  
  //====== Start Choosen Dropdown===========
const [chosenValues, setChosenValues] = useState({
  "ContractNo": {"id": "0","name": t(DispensingLanguage[lan][menukey]["All"])},
  "ItemCode": {"id": "0","name": t(DispensingLanguage[lan][menukey]["All"])}
});
const [chosenValuesFacility, setChosenValuesFacility] = useState({
  
});


const handleChangeChoosenContact = (name, valueobj, value) => {
  let chosenValuesData = { ...chosenValues};
  chosenValuesData[name] = valueobj;
  setChosenValues(chosenValuesData); 

  setFirstLoad(true);
  setLoading(false);
  setcurrContractNo(value);

};

const handleChangeChoosenItem = (name, valueobj, value) => {
  let chosenValuesData = { ...chosenValues};
  chosenValuesData[name] = valueobj;
  setChosenValues(chosenValuesData); 

  setFirstLoad(true);
  setLoading(false);
  setcurrItemCode(value);

};

const handleChangeChoosenFacility = (name, valueobj, value) => {
  let chosenValuesDataFacility = { ...chosenValuesFacility};
  chosenValuesDataFacility[name] = valueobj;
  setChosenValuesFacility(chosenValuesDataFacility); 

  setFirstLoad(true);
  setLoading(false);
  setcurrFacilityCode(value);
  setcurrFacilityName(valueobj.name);

};
//====== End Choosen Dropdown===========

  const [selectedStartDate, setSelectedStartDate] = React.useState(
    moment().subtract(30, "days").format("YYYY-MM-DD")
  );

  const [selectedEndDate, setSelectedEndDate] = React.useState(
    moment().format("YYYY-MM-DD")
  );

  const handleStartDateChange = (date) => {
    setFirstLoad(true);
    setLoading(true);
    setSelectedStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setFirstLoad(true);
    setLoading(true);
    setSelectedEndDate(date);
  };

  

    const handleChange = (event) => {
      setFirstLoad(true);
      setLoading(false);
      setcurrContractNo(event.target.value);
    };



  const handleChangeItemCode = (event) => {
    
    setFirstLoad(true);
    setLoading(false);
    setcurrItemCode(event.target.value);

  };


  
  if(Conractcheck){
    setConractcheck(false);
    
    let ParamList={action:"ContractlistAll"}
    Service.default
        .postApi("source/combo_generic.php",ParamList)
        .then((res) => {
          let All_Contact_label = {id:"0", name: t(DispensingLanguage[lan][menukey]["All"])};
          const Contact_List = [All_Contact_label].concat(res.datalist); 
          setContractlistAll(Contact_List); 
         
        })
        .catch((err) => {});
  }
   


  const cItemList = () => {  
  
    let ItemListParam = {action:"ItemList", GroupCode:'', FacilityId: FacilityId, menukey:""}

    Service.default
        .postApi("source/combo_generic.php",ItemListParam)
        .then((res) => { 

          let All_Item_label = {id:"0", name: t(DispensingLanguage[lan][menukey]["All"])};
          const Item_List = [All_Item_label].concat(res.datalist); 

           setItemListLocal(Item_List); 
        })
        .catch((err) => {});
  
}




  let params = {
    menukey: menukey,
    FacilityId: currFacilityCode,
    action: "getDataListGlobal",
    StartDate: moment(selectedStartDate).format("YYYY-MM-DD"),
    EndDate: moment(selectedEndDate).format("YYYY-MM-DD"),
    page_limit: JSON.stringify(100),
    page_number: JSON.stringify(0 + 1),
    search_key: "",
    //RadioValue: radioValue,
    ContractNo: currContractNo,
    ItemCode: currItemCode,
  };

  const [isLoading, setLoading] = useState(false);

  const { error, isError, data, refetch:stockData } = useQuery(
    [params],
    api.ProvisionalSummaryReport,
    {
      onSuccess: (data) => {
        if(firstLoad){
          /* localStorage.setItem(
            "StockData",
            JSON.stringify(data)
          );
           */
          setDataItems(data);
          setLoading(false);
          setFirstLoad(false);
        }
      },
        refetchOnWindowFocus: false,
        refetchOnmount: false,
        refetchOnReconnect: false,
        retry: false,
        staleTime: 0
  }
  ); 

  const UseFor = localStorage.getItem("UseFor");
  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintPDFExcelExportFunction = (reportType) => {
    let formatedstartDate = moment(selectedStartDate).format("YYYY-MM-DD");
    let formatedendDate = moment(selectedEndDate).format("YYYY-MM-DD");
    let finalUrl = EXCEL_EXPORT_URL + "report/provisional_summary_report_print_excel.php";

    window.open(
      finalUrl +
        "?action=ProvisionalSummaryReporExportGlobal" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&StartDate=" +
        formatedstartDate +
        "&EndDate=" +
        formatedendDate +
        "&FacilityId=" +
        currFacilityCode +
        "&ContractNo=" +
        currContractNo +
        "&ItemCode=" +
        currItemCode +
        "&UseFor=" +
        UseFor +
        /* "&RadioValue=" +
        radioValue + */
        "&FacilityName=" +
        currFacilityName + "&TimeStamp=" + Date.now()
    );
  };
  /* =====End of Excel Export Code==== */

  const columns = [
    {
      title: "Id",
      field: "id",
      visible: false,
    },
    {
      title: DispensingLanguage[lan][menukey]["Sl#"],
      hozAlign: "center",
      width: 5,
      formatter: "rownum",
      headerHozAlign: "center",
      headerSort: false,
    },
    /* {
      title: DispensingLanguage[lan][menukey]["Item Code"],
      field: "ItemCode",
      headerFilter: false,
      width: "10%",
    }, */
   
    /* {
      title: DispensingLanguage[lan][menukey]["Date Received"],
      field: "StockDate",
      headerFilter: true,
      width: "10%",
    },  */
    {
      title: DispensingLanguage[lan][menukey]["Package Serial NoS"],
      field: "PackageName",
      headerFilter: true,
      width: 110,

    },
    {
      title: DispensingLanguage[lan][menukey]["Contract NoS"],
      field: "ContractName",
      headerFilter: true,
      minWidth: 140,

    },
    {
      title: DispensingLanguage[lan][menukey]["Contract Quantity"],
      field: "ContractQty",
      hozAlign: "right",
      headerHozAlign: "right",
      headerFilter: false,
      width: 110,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        return value == 0 ? "" : Number(value).toLocaleString();
      },

    },
    {
      title: DispensingLanguage[lan][menukey]["Provisional Received Quantity"],
      field: "PreceiveQty",
      hozAlign: "right",
      headerHozAlign: "right",
      headerFilter: false,
      width: 110,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        return value == 0 ? "" : Number(value).toLocaleString();
      },

    },
   
    {
      title: DispensingLanguage[lan][menukey]["Disapproved Quantity"],
      field: "DisapprovedQty",
      hozAlign: "right",
      headerHozAlign: "right",
      headerFilter: false,
      width: 110,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        return value == 0 ? "" : Number(value).toLocaleString();
      },

    },
    {
      title: DispensingLanguage[lan][menukey]["Direct Return Quantity"],
      field: "DirectReturnQuantity",
      hozAlign: "right",
      headerHozAlign: "right",
      headerFilter: false,
      width: 110,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        return value == 0 ? "" : Number(value).toLocaleString();
      },

    },
    {
      title: DispensingLanguage[lan][menukey]["Return To Supplier"],
      field: "QtyReturn",
      hozAlign: "right",
      headerHozAlign: "right",
      headerFilter: false,
      width: 110,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        return value == 0 ? "" : Number(value).toLocaleString();
      },

    },
    {
      title: DispensingLanguage[lan][menukey]["Provisional Due Quantity"],
      field: "QtyBalance",
      hozAlign: "right",
      headerHozAlign: "right",
      headerFilter: false,
      width: 110,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        return value == 0 ? "" : Number(value).toLocaleString();
      },

    },
    {
      title: DispensingLanguage[lan][menukey]["Approved Quantity"],
      field: "ApprovedQty",
      hozAlign: "right",
      headerHozAlign: "right",
      headerFilter: false,
      width: 110,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        return value == 0 ? "" : Number(value).toLocaleString();
      },

    },
    
       
   
  ];




  const checkLogin = () => {
    let token = Constants.token;

    if (!token) {
      swal("Oops!", `token expired. Please login again`, "error");
      props.history.push("/login");
    }
  };


  React.useEffect(() => {
    setcurrItemCode(0); 
    cItemList();
  }, []);


 React.useEffect(() => {
   if (tblRef == null) return;
   setLoading(true);
   stockData();
  }, [selectedStartDate, selectedEndDate, currContractNo,currItemCode]);

  return (
    <>
      <div className={classes.productPageTitle}>
        <div className="d-flex justify-product mb-2">
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {DispensingLanguage[lan][menukey]["Provisional Summary Report"]}
              </div>
            </div>
          </Grid>
        </div>

        {/* start of filter */}
        <Card className="sw_card sw_filter_card">
          <CardContent className="sw_filterCardContent">
            <Grid container>
            <Grid item xs={2} sm={2}>
                    <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                           
                            disableClearable
                            id="FacilityCode"
                            options={FacilityList}
                            onChange={(event, valueobj) => handleChangeChoosenFacility('FacilityCode', valueobj, valueobj?valueobj.id:"")}
                            getOptionLabel={(option) => option.name}
                           
                            defaultValue={FacilityList[FacilityList.findIndex(facilitylist => facilitylist.id == currFacilityCode)]}
                            renderOption={(option) => (
                            <Typography className="sw_fontSize">{option.name}</Typography>
                            )}
                            renderInput={(params) => (
                            <TextField
                              {...params}
                              label={DispensingLanguage[lan][menukey]["Facility"]}
                              variant="standard"
                              id="FacilityCode"
                              name="FacilityCode"
                              fullWidth
                            />
                            )}
                          />

                    </FormControl>
                  </Grid>
              <Grid item xs={2} sm={2}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container justifyContent="space-around">
                    <KeyboardDatePicker
                      className={classes.fullWidth}
                      //disableToolbar
                      autoOk={true}
                      // disabled={true}
                      variant="inline"
                      format="dd/MM/yyyy"
                      id="date-picker-inline"
                      label={DispensingLanguage[lan][menukey]["Start Date"]}
                      value={selectedStartDate}
                      onChange={handleStartDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </Grid>

              <Grid item xs={2} sm={2}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container justifyContent="space-around">
                    <KeyboardDatePicker
                      className={classes.fullWidth}
                      variant="inline"
                      format="dd/MM/yyyy"
                      id="date-picker-inline"
                      label={DispensingLanguage[lan][menukey]["End Date"]}
                      autoOk={true}
                      value={selectedEndDate}
                      onChange={handleEndDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </Grid>


              <Grid item xs={3} sm={3}>
                <FormControl className={classes.fullWidth}>
                

                  <Autocomplete
                    autoHighlight
                    disableClearable
                    id="ContractNo"
                    options={ContractlistAll}
                    onChange={(event, valueobj) => handleChangeChoosenContact('ContractNo', valueobj, valueobj?valueobj.id:"")}
                    getOptionLabel={(option) => option.name}
                    value={chosenValues['ContractNo']}
                    renderOption={(option) => (
                    <Typography className="sw_fontSize">{option.name}</Typography>
                    )}
                    renderInput={(params) => (
                    <TextField
                    {...params}
                    label={DispensingLanguage[lan][menukey]["Contact"]}
                    variant="standard"
                    id="ContractNo"
                    name="ContractNo"
                    fullWidth
                    />
                    )}
                  />

                </FormControl>
                  </Grid>

                   <Grid item xs={2} sm={2}>
                    <FormControl className={classes.fullWidth}>
                      

                      <Autocomplete
                        autoHighlight
                        disableClearable
                        id="ItemCode"
                        options={ItemList}
                        onChange={(event, valueobj) => handleChangeChoosenItem('ItemCode', valueobj, valueobj?valueobj.id:"")}
                        getOptionLabel={(option) => option.name}
                        value={chosenValues['ItemCode']}
                        renderOption={(option) => (
                        <Typography className="sw_fontSize">{option.name}</Typography>
                        )}
                        renderInput={(params) => (
                        <TextField
                        {...params}
                        label={DispensingLanguage[lan][menukey]["Item"]}
                        variant="standard"
                        id="ItemCode"
                        name="ItemCode"
                        fullWidth
                        />
                        )}
                      />
                    </FormControl>
                  </Grid> 

              <Grid item xs={1} sm={1}>
                <div className="float-right sw_btn_control">

                <ExportButtons PrintPDFExcelExportFunction={PrintPDFExcelExportFunction}  {...props}></ExportButtons>
                 
                </div>
              </Grid>

            </Grid>
          </CardContent>
        </Card>
        {/* end of filter */}

        <div className="sw_relative">
          {isLoading && <LoadingSpinnerOpaque />}

          <div className="uniqueName">
            <ReactTabulator
              ref={(r) => (tblRef = r)}
              columns={columns}
              data={dataItems}
              layout={"fitColumns"}
              height="400px"
              // groupBy="GroupName"
              options={{
                  groupBy: ["GroupItemName"],
                  //groupBy: ["ItemName"],
                  //groupBy: "GroupName",
                  columnCalcs: "both",
                }}
             // rowDblClick={(e, row) => tableRowDoubleClick(e, row)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProvisionalSummaryReportGlobal;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    background: "whitesmoke",
    color: "black",
    borderRadius: "10px",
    padding: "1rem",
  },
  tableContainer: { backgroundColor: "whitesmoke", borderRadius: "10px" },
  fullWidth: {
    width: "95%",
  },
  filterDiv: {
    width: "80%",
    display: "flex",
  },
});
